import DialogAlertAction from "components/DialogAlertAction/DialogAlertAction";

const SpaceDialogAction = ({
	dialog, title, 
	content, contentComponent,
	children
}) => {
	return (
		<DialogAlertAction
			show={dialog.value}
			toggleShow={dialog.toggle}
			width="700px"
			widthContent="100%"
			variant="secondary"
			title={title}
			content={content}
			contentComponent={contentComponent}>
			{children}
		</DialogAlertAction>
	);
}

export default SpaceDialogAction;